//const apiUrl = 'https://localhost:44301/api'
const apiUrl = 'https://api.moskit-polichat.fasam.edu.br/api'
const cookie_token = '_integration_cook'

export default{
    apiUrl,
    cookie_token
}